import { inject } from '@angular/core';
import { Router } from '@angular/router';
import { first, map } from 'rxjs';

import { AuthService } from '../services/auth.service';

export const securityProfileAuthTokenGuard = () => {
  const router = inject(Router);
  const authService = inject(AuthService);

  return authService.securityProfileAuthToken$.pipe(
    first(),
    map((token) => {
      if (token) {
        return true;
      }

      return router.createUrlTree(['/security-profiles']);
    }),
  );
};
